/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Payments_AmountInputs */

const cs_deal_payments_amount = /** @type {(inputs: Deal_Payments_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Částka`)
};

const en_deal_payments_amount = /** @type {(inputs: Deal_Payments_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Deal_Payments_AmountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_payments_amount = /** @type {((inputs?: Deal_Payments_AmountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Payments_AmountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_payments_amount(inputs)
	return cs_deal_payments_amount(inputs)
});